<template>
    <main>

        <!-- breadcrumb-area-start -->
        <div class="it-breadcrumb-area it-breadcrumb-bg"
            :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="it-breadcrumb-content z-index-3 text-center">
                            <div class="it-breadcrumb-title-box">
                                <h3 class="it-breadcrumb-title">contact us</h3>
                            </div>
                            <div class="it-breadcrumb-list-wrap">
                                <div class="it-breadcrumb-list">
                                    <span><a href="#">home</a></span>
                                    <span class="dvdr">//</span>
                                    <span>contact</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- breadcrumb-area-end -->

        <!-- contact-area-start -->
        <div class="it-contact__area pt-120 pb-120">
            <div class="container">
                <div class="it-contact__wrap fix z-index-3 p-relative">
                    <div class="it-contact__shape-1 d-none d-xl-block">
                    </div>
                    <div class="row align-items-end">
                        <div class="col-xl-7">
                            <div class="it-contact__right-box">
                                <div class="it-contact__section-box pb-20">
                                    <h4 class="it-contact__title pb-15">Get in Touch</h4>
                                    <p>We would like to help us</p>
                                </div>
                                <div class="it-contact__content mb-55">
                                    <ul>
                                        <li>
                                            <div class="it-contact__list d-flex align-items-start">
                                                <div class="it-contact__icon">
                                                    <span><i class="fa-solid fa-location-dot"></i></span>
                                                </div>
                                                <div class="it-contact__text">
                                                    <span>Our Address</span>
                                                    <a href="#">Santoshi Mata Mandir Road, Near New High School, Malhar
                                                        Nagar, Joshibaug, Kalyan(W)-421 301</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="it-contact__list d-flex align-items-start">
                                                <div class="it-contact__icon">
                                                    <span><i class="fa-solid fa-clock"></i></span>
                                                </div>
                                                <div class="it-contact__text">
                                                    <span>Hours of Operation</span>
                                                    <a href="#">Mon - Sat: 9.00am to 5.00pm</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="it-contact__list d-flex align-items-start">
                                                <div class="it-contact__icon">
                                                    <span><i class="fa-solid fa-phone phone"></i></span>
                                                </div>
                                                <div class="it-contact__text">
                                                    <span>contact</span>
                                                    <a href="tel:+99358954565">9619392909/9920892909/7506084881 </a>
                                                    <a href="mailto:info@aime.ac.in">info@aime.ac.in</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="it-contact__bottom-box d-flex align-items-center justify-content-between">
                                    <div class="it-footer-social">
                                        <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
                                        <a href="#"><i class="fa-brands fa-instagram"></i></a>
                                        <a href="#"><i class="fa-brands fa-pinterest-p"></i></a>
                                        <a href="#"><i class="fa-brands fa-twitter"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5">
                            <div class="it-contact__form-box">
                                <div class="mapouter">
                                    <div class="gmap_canvas">
                                        <iframe width="600" height="600" id="gmap_canvas"
                                            src="https://maps.google.com/maps?q=Santoshi%20Mata%20Mandir%20Road,%20Near%20New%20High%20School,%20Malhar%20Nagar,%20Joshibaug,%20Kalyan(W)-421%20301&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                            frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                        <a href="https://embedgooglemap.net/124/"></a><br>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- contact-area-end -->

    </main>
</template>
<script>
export default {
    name: "contactView"
};
</script>
